module.exports = __webpack_public_path__ + "img/home-pic-9.a4edeb09.jpg";